import React, { Component } from "react";
import withRouter from "./Common/withRouter";
// import { withRouter } from "react-router-dom";

class NonAuthLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.capitalizeFirstLetter.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    const { pathname } = this.props.router.location;

    // Extract last part of URL e.g. "/role-list" → "role-list"
    let currentPage = pathname.split("/").pop();

    // Fallback for home route "/"
    if (!currentPage) currentPage = "Dashboard";

    // Convert "role-list" → "Role List"
    currentPage = currentPage
      .replace(/-/g, " ") // replace hyphens with spaces
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word

    document.title = `${currentPage} | RMS`;
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

export default withRouter(NonAuthLayout);
